import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from "react-router";
import { useCommonStore } from "@/store/useCommonStore";
import { BuildCustomForm, BuildMiniForm } from "wsc-react-custom-form";
import useRequest from '@/utils/useRequest';
import {
  FormCode, FlowDict, FormNodeSwitch, FormDateTimeSelect, FormIdTypeSelect, 
  FormDeptTreeSelect, FormRoleSelect, FormAreaSelect, FormIconSelect, 
  FormColorSelect, FormImageUpload, FormQuillEditor, FormUserSelect,
  FormMenuFuncSelect, FormRoleMenuFuncSelect, FormCategoryTreeSelect
} from '@/component/exComponents';
import {
  MiniFormImageUpload, MiniFormRadio, MiniFormCity, MinFormAtCalendar, MiniBusiDataMap, MiniFormStartButton, MiniFormDisposeButton
} from '@/component/exComponentsMini';
import { message, Spin } from "antd";

const BuildFormV2 = (props) => {
  const { request } = useRequest();
  const { id } = useParams();

  const [ready, setReady] = useState(false);
  const [schema, setSchema] = useState([]);
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);

  const sysdicts = useCommonStore.use.sysdicts();

  useEffect(() => {
    const req = async () => {
      const result = await request("/api/v2/private/dynamicform/schema/get", "POST", "json", { id: id });
      if (result.success) {
        setSchema(result.data.Data);
        setFormData(result.data);
        setReady(true);
      }
    }
    setLoading(true);
    req();
    setLoading(false);

  }, [id]);


  const saveDynamicFormSchema = useCallback(async (id, schema) => {
    //setLoading(true);
    try {
      const result = await request('/api/v2/private/dynamicform/schema/save', 'POST', 'json', { id, schema });
      if (result.success) {
        message.success('保存成功');
      } else {
        message.error('保存失败');
      }
    } catch (error) {
      message.error('出错了' + error.message);
    } finally {
      //setLoading(false);
    }
  }, [])

  if (!ready) return null;

  if (formData.AppCategory === 'Mini') {
    console.log('Mini form');
    return (
      <Spin spinning={loading}>
        <BuildMiniForm
          schema={schema}
          OnPayload={(name, payload) => {
          }}
          exComponents={[MiniFormImageUpload, MiniFormRadio, MiniFormCity, MinFormAtCalendar, MiniBusiDataMap, MiniFormStartButton, MiniFormDisposeButton
          ]}
          OnSave={(schema) => {
            saveDynamicFormSchema(id, schema);
            console.log(schema);
          }}
          formdata={{}}
          sysdicts={sysdicts}
        />
      </Spin>
    );
  }

  return (
    <BuildCustomForm
      schema={schema}
      OnPayload={(name, payload) => {

      }}
      exComponents={[FormCode, FlowDict, FormNodeSwitch, FormDateTimeSelect, 
        FormIdTypeSelect, FormDeptTreeSelect, FormRoleSelect, FormAreaSelect, 
        FormIconSelect, FormColorSelect, FormImageUpload, FormQuillEditor, 
        FormUserSelect, FormMenuFuncSelect, FormRoleMenuFuncSelect, FormCategoryTreeSelect
      ]}
      OnSave={(schema) => {
        saveDynamicFormSchema(id, schema);
        console.log(schema);
      }}
      formdata={{}} sysdicts={sysdicts}
    />
  );
}



export default BuildFormV2;